import  PageHero from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import { BRAND , IMAGES } from "@/lib/site";
import { Link } from "react-router-dom";

const sections = [
  {
    title: "1. Acceptance of Terms",
    content: [
      `By accessing and using the ${BRAND.name} website, you agree to comply with these Terms & Conditions. If you do not agree with any part of these terms, please discontinue using this website.`,
    ],
  },
  {
    title: "2. Website Usage",
    content: [
      "This website is intended to provide information about our products, services and manufacturing capabilities.",
      "Users agree not to misuse, copy or interfere with the website or its services.",
    ],
  },
  {
    title: "3. Product Information",
    content: [
      "All product specifications, dimensions, finishes and images are provided for general reference only.",
      "Stenzia Displays LLP reserves the right to improve or modify products without prior notice.",
    ],
  },
  {
    title: "4. Quotations & Pricing",
    list: [
      "All quotations are subject to confirmation.",
      "Prices may change without prior notice.",
      "Freight, taxes and duties may be charged separately unless mentioned.",
      "Only written quotations issued by Stenzia Displays LLP are considered valid.",
    ],
  },
  {
    title: "5. Orders & Manufacturing",
    list: [
      "Production begins only after order confirmation.",
      "Delivery timelines may vary depending on project scope.",
      "Custom-made products cannot be cancelled once production has started.",
    ],
  },
  {
    title: "6. Intellectual Property",
    content: [
      "All website content including logos, product photographs, designs, drawings, catalogues, graphics and text remain the intellectual property of Stenzia Displays LLP.",
      "Unauthorized copying or reproduction is strictly prohibited.",
    ],
  },
  {
    title: "7. Limitation of Liability",
    content: [
      "While we strive to keep all information accurate and up to date, Stenzia Displays LLP shall not be liable for any direct, indirect or consequential damages arising from the use of this website.",
    ],
  },
  {
    title: "8. Governing Law",
    content: [
      "These Terms & Conditions shall be governed by the laws of India. Any disputes shall be subject to the jurisdiction of the courts in Gujarat, India.",
    ],
  },
  {
    title: "9. Contact Information",
    content: [
      "For any legal, commercial or business-related questions regarding these Terms & Conditions, please contact our team.",
    ],
  },
];

export default function TermsConditions() {
  return (
    <>
      <PageHero
        overline="Legal"
        title="Terms & Conditions"
        subtitle="Please read these terms carefully before using our website or requesting a quotation."
        image={IMAGES.PrivacyTerm}
      />

      <section className="py-24 bg-white">
        <div className="max-w-5xl mx-auto px-6">

          <Reveal>
            <div className="mb-12 rounded-2xl border border-stone-200 bg-stone-50 p-6">
              <div className="text-sm uppercase tracking-[0.2em] text-stenzia-green font-semibold">
                Last Updated
              </div>

              <h2 className="mt-3 text-2xl font-display">
                July 2026
              </h2>

              <p className="mt-4 text-stone-600 leading-relaxed">
                These Terms & Conditions govern the use of the
                Stenzia Displays LLP website and all inquiries,
                quotations and communications made through it.
              </p>
            </div>
          </Reveal>

          <div className="space-y-8">

            {sections.map((section) => (

              <Reveal key={section.title}>

                <div className="rounded-3xl border border-stone-200 p-8 transition-all duration-500 hover:-translate-y-1 hover:border-stenzia-green/30 hover:shadow-xl">

                  <h2 className="text-2xl font-display text-charcoal">
                    {section.title}
                  </h2>

                  {section.content &&
                    section.content.map((paragraph, index) => (
                      <p
                        key={index}
                        className="mt-5 leading-8 text-stone-600"
                      >
                        {paragraph}
                      </p>
                    ))}

                  {section.list && (
                    <ul className="mt-5 space-y-3">

                      {section.list.map((item) => (

                        <li
                          key={item}
                          className="flex items-start gap-3"
                        >
                          <span className="mt-2 h-2 w-2 rounded-full bg-stenzia-green"></span>

                          <span className="leading-7 text-stone-600">
                            {item}
                          </span>

                        </li>

                      ))}

                    </ul>
                  )}

                </div>

              </Reveal>

            ))}

          </div>

          <Reveal>
            <div className="mt-16 rounded-3xl bg-charcoal p-10 text-center text-white">
              <div className="text-sm uppercase tracking-[0.25em] text-stenzia-gold">
                Need Assistance?
              </div>

              <h2 className="mt-4 text-3xl font-display">
                Have questions regarding our terms?
              </h2>

              <p className="mx-auto mt-5 max-w-2xl text-white/70 leading-8">
                Our team will be happy to explain our quotation process,
                manufacturing policies, delivery terms and product information.
              </p>

              <Link
  to="/contact"
  className="mt-8 inline-flex rounded-full bg-white px-8 py-4 text-sm font-medium text-charcoal transition-all duration-300 hover:bg-stenzia-gold"
>
  Contact Us
</Link>
            </div>
          </Reveal>

        </div>
      </section>
    </>
  );
}